import { useQuery } from "react-query";
import { UPLOAD_CUSTOMER_DOCUMENT } from "../../../../api/ajax-endpoints";
import { getData } from "../../../../newApis/dotNetApiMethods";
import { ICustomerKycDocument } from "../../../../interfaces/businessProfile";

type TQuery = {
  customerId?: number;
};

export const useGetCustomerDocumentsForAdmin = ({ customerId }: TQuery) => {
  return useQuery<ICustomerKycDocument[]>(
    [{ customerId }, "getCustomerDocumentsForAdmin"],
    async () => {
      const res = await getData(
        `${UPLOAD_CUSTOMER_DOCUMENT}?sourceAppId=5&funderId=${customerId}`,
      );
      return res?.data?.data ?? [];
    },
    {
      enabled: !!customerId,
    },
  );
};
